export const formatCurrency = (value, currency = 'USD') => {
  const currencyMap = {
    USD: 'USD',
    USDT: 'USD',
    EUR: 'EUR',
  };
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyMap[currency] || 'USD',
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatCompact = (value) =>
  new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 3,
  }).format(value);

export const formatCompactCurrency = (value, currency = 'USD') => {
  const currencySymbol = currency === 'EUR' ? '€' : '$';
  const compact = formatCompact(value);
  return `${currencySymbol}${compact}`;
};

